import { bool, object, objectOf, string } from 'prop-types';
import React from 'react';
import Pricing from '../../../Pricing/Pricing';
import PricingHelper from '../../../Pricing/PricingHelper';
import config from '../../ProductCard.config';

const ProductPrice = ({
    cardTheme,
    deviceType,
    displayEach,
    eligibilityMessage,
    ppId,
    price,
    pricingConfig,
}) => {
    const priceWrapper = [
        'flex flex-wrap',
        'items-baseline',
        'm-0',
        'pt-0',
        'text-medium',
        'whitespace-normal',
        cardTheme == 'cartridge' ? 'overflow-hidden text-xsmall' : '',
    ].join(' ');

    const mainPrice = [cardTheme == 'cartridge' ? 'inline-block text-xsmall' : ''].join(' ');

    return (
        <div
            className={cardTheme}
            data-automation-id="product-price"
            data-component-name="ProductPrice"
        >
            <Pricing
                cardTheme={cardTheme}
                deviceType={deviceType}
                displayEach={displayEach}
                dynamicFont={cardTheme === config.cardTheme.CARTRIDGE}
                eligibilityMessage={eligibilityMessage}
                mainPriceClass={mainPrice}
                ppId={ppId}
                priceWrapperClass={priceWrapper}
                pricingConfig={pricingConfig}
                pricingDetails={PricingHelper(price)}
            />
        </div>
    );
};

ProductPrice.propTypes = {
    cardTheme: string,
    deviceType: objectOf(bool),
    displayEach: bool,
    eligibilityMessage: string,
    ppId: string,
    price: object,
    pricingConfig: object,
};

ProductPrice.defaultProps = {
    cardTheme: '',
    deviceType: {},
    displayEach: false,
    eligibilityMessage: '',
    ppId: '',
    price: null,
    pricingConfig: {},
};

export default ProductPrice;
